import LacunaWebPKI from "web-pki";
import { mapState } from "vuex"

let webPkiLicense = 'AiYAaWNjYi5wbGF0YWZvcm1haWR0LmlvLHBsYXRhZm9ybWFpZHQuaW9eAGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTcyLjE2LjAuMC8xMixpcDQ6MTkyLjE2OC4wLjAvMTYscGxheS1pY2NiLnBsYXRhZm9ybWFpZHQuaW8DAFBybwgAAFhYy6zB3wgAAd8HDZcP1IUQRDGStShOqVgxrTSjHUt2CHQYlNOzPHlboCcOiv4pJUI1pI1Mft1xexMEhmD7hIb4Lu4BlEHPDypCnylXS/ameUNmRhytaMSiROpbp2trWSnZXwqIS1Sb1WEWLqL5Ps6PYOF9BkQk/luGjkyD3JqllEvzz0RgsOdUdenPGNpdO/iLhQuo/N6Nz0guD30fO/MNc8DcdRedIM+tHwEs5f+irSNlGIrp3vOjSlK257QFk4iJwaVf0X9ovIMjMi58cu7quxu4WXjwNoZhTYGglrK/FZ1UJbbNBzq/vlYgm7pavSZSp6yL8hQu4p+S5/rCcExzwhen/iE/Dw4=';

export default {
  data() {
    return {
      pki: {},
      isExtensionInstalled: true,
      certificates: [],
      thumbprint: {}
    }
  },
  created: function () {
    this.pki = new LacunaWebPKI(webPkiLicense)
    if(this.loadWebPKIPlugin){
      this.initWebPKI()
    }
  },
  watch:{
    loadWebPKIPlugin(newVal){
      if(newVal === true){
        this.initWebPKI()
      }
    }
  },
  computed: {
    ...mapState({
      loadWebPKIPlugin: 'loadWebPKIPlugin'
    })
  },
  methods: {
    onWebPkiReady: function () {
      this.isExtensionInstalled = true
      this.loadCertificates()
    },
    initWebPKI(){
      this.pki.init({
        ready: this.onWebPkiReady,
        notInstalled: this.onWebPkiNotInstalled
      })
    },
    loadCertificates() {
      this.pki.listCertificates().success(certs => {
        this.certificates = certs;
      })
    },
    readCertificate(thumbprint) {
      return this.pki.readCertificate(thumbprint)
    },
    onWebPkiNotInstalled: function () {
      this.isExtensionInstalled = false
    },
    redirectToInstallPage() {
      this.pki.redirectToInstallPage()
    }
  }
}
